<ion-header class="ion-no-border">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-title [subtitle]="fullName" translate>perfil.titol</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <ion-card>
    <ion-item lines="none" button (click)="editProfile()">
      <ion-icon name="user" slot="start"></ion-icon>
      <ion-label translate>perfil.edit</ion-label>
      <ion-icon name="fwd" color="primary" slot="end"></ion-icon>
    </ion-item>
  </ion-card>

  <ion-card>
    <ion-item lines="none" button id="lang-modal">
      <ion-icon name="lang" slot="start"></ion-icon>
      <ion-label translate>treballadors.idioma</ion-label>
      <ion-icon name="fwd" color="primary" slot="end"></ion-icon>
    </ion-item>
  </ion-card>

  <!-- no implementat encara -->
  <!-- <ion-card>
    <ion-item lines="none">
      <ion-icon name="notis" slot="start"></ion-icon>
      <ion-label translate>perfil.notis</ion-label>
      <ion-icon name="fwd" color="primary" slot="end"></ion-icon>
    </ion-item>
  </ion-card>

  <ion-card>
    <ion-item lines="none">
      <ion-icon name="location" slot="start"></ion-icon>
      <ion-toggle translate style="font-size:15px;color:#7e7e7e;font-weight:400;letter-spacing: -.5px">
        perfil.loc
      </ion-toggle>
    </ion-item>
  </ion-card> -->

  <ion-card *ngIf="prl()">
    <ion-item lines="none" (click)="setView(view!='worker'?'worker':'admin')">
      <ion-icon [name]="view" color="primary" slot="start">
      </ion-icon>
      <ion-label style="color:var(--ion-color-primary)!important">
        {{ view != 'worker' ? ('perfil.worker' | translate) : ('perfil.admin' | translate) }}
      </ion-label>
    </ion-item>
  </ion-card>

  <ion-card>
    <ion-item lines="none" (click)="disconnect()">
      <ion-icon name="logout" slot="start" color="danger"></ion-icon>
      <ion-label style="color:var(--ion-color-danger)!important">{{ 'perfil.disconnect' | translate: { company: companyName } }}</ion-label>
    </ion-item>
  </ion-card>

  <ion-card>
    <ion-item lines="none" (click)="logout()">
      <ion-icon name="logout" slot="start" color="danger"></ion-icon>
      <ion-label style="color:var(--ion-color-danger)!important" translate>perfil.logout</ion-label>
    </ion-item>
  </ion-card>

</ion-content>


<!-- <ion-modal trigger="lang-modal" [breakpoints]="[0, .5]" [initialBreakpoint]=".5">
  <ng-template>
    <ion-content class="ion-padding" style="--ion-padding: 1em">
      <ion-radio-group [value]="currentLang" (ionChange)="setLang($event.detail?.value || 'ca')">
        <ion-list lines="none" style="border-radius:1em">
          <ion-list-header lines="full" translate>perfil.lang</ion-list-header>
          @for (lng of ['ca', 'es', 'en']; track lng) {
            <ion-item>
                <ion-radio [value]="lng" color="primary" translate>perfil.{{lng}}</ion-radio>
            </ion-item>
          }
        </ion-list>
      </ion-radio-group>
    </ion-content>
  </ng-template>
</ion-modal> -->

<ion-alert trigger="lang-modal" header="{{ 'perfil.lang' | translate }}" [buttons]="[ 'perfil.fet' | translate ]"
  [inputs]="langinputs" (didDismiss)="setLang($event.detail.data.values)"></ion-alert>
